import { Component } from '@angular/core';
import { SkeletonComponent } from '../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-assessment-detail-skeleton',
  templateUrl: './assessment-detail-skeleton.component.html',
  styleUrls: ['./assessment-detail-skeleton.component.css'],
  imports: [SkeletonComponent],
})
export class AssessmentDetailSkeletonComponent {
  readonly infoRows = [1, 2, 3, 4];
  readonly analysisCells = [1, 2, 3];
  readonly dimensionRows = [1, 2, 3, 4, 5, 6];
}
